import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { twMerge } from "../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
const SidebarNavItem = forwardRef((props, ref) => {
  const { children, isActive = false, className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "a",
    {
      ...rest,
      ref,
      className: twMerge(
        "flex text-grayscale-500 font-medium text-sm leading-normal px-4 py-2 cursor-pointer rounded-lg",
        isActive ? "bg-primary text-primary-contrast" : "hover:bg-primary/5",
        className
      ),
      children
    }
  );
});
export {
  SidebarNavItem as default
};
//# sourceMappingURL=SidebarNavItem.js.map
